module.exports = __webpack_public_path__ + "img/eagle.86b7930f.svg";